export const getEventId = (event) =>
  (event.detail?.event_id || '').replace(/_/g, '-');
